import React from "react"
import "./loading.scss"

const Loading = ({ noMargin }) => (
  <div className="loading-container">
    <div className={`loading-content-container ${noMargin && "no-margin"}`}>
      <div className="spinner">
        <div className="rect1"></div>
        <div className="rect2"></div>
        <div className="rect3"></div>
        <div className="rect4"></div>
        <div className="rect5"></div>
      </div>

      <div className="loading-title">Loading...</div>
    </div>
  </div>
)

export default Loading
